import {GetBrigadesChips} from "../Balance";

class RepairShop{
    constructor(id, parentStationID, sparePartsType, brigades) {
        this.id = id;
        this.partsType = sparePartsType;
        this.partsCount = 20;
        this.brigades = brigades;
        this.brigadesChips = 0;
        this.additionalChips = 0;
        this.parentStationID = parentStationID;
        this.stages = [[],[],[],[]]
    }
    copy(repairShop){
        this.id = repairShop.id;
        this.partsType = repairShop.partsType;
        this.partsCount = repairShop.partsCount;
        this.brigades = repairShop.brigades;
        this.brigadesChips = repairShop.brigadesChips;
        this.parentStationID = repairShop.parentStationID;
        this.additionalChips = repairShop.additionalChips;
        this.stages = repairShop.stages;

    }
    processStages(firstStageResource, secondStageResource, thirdStageResource ){
        while (firstStageResource !== 0)
        {
            firstStageResource--;
            let loco =  this.repairStageOne.pop();
            loco.state = 10;
        }
        while (secondStageResource !== 0) {
            secondStageResource--;
            let loco =  this.repairStageTwo.pop();
            this.repairStageOne.push(loco);
        }
        while (thirdStageResource !== 0) {
            thirdStageResource--;
            let loco =  this.repairStageThree.pop();
            this.repairStageTwo.push(loco);
        }
    }
    renew(){
        this.brigadesChips = GetBrigadesChips("repair") * this.brigades;
    }
    isLocoRepairing(loco){
        for (let i = 0; i < this.stages.length; i++){
            if(this.stages[i].includes(loco.id))
                return true;
        }
        return false;
    }
}
export default RepairShop;
